<template>
  <div>
    <!-- Basic Details -->
    <basic-details
      :matter="$store.state.matterStore.currentmatter"
    />
    <!-- Case Status -->
    <div
      v-if="
        Object.keys($store.state.matterStore.currentmatter).includes(
          'case_details'
        )
      "
    >
      <case-status
        :matter="$store.state.matterStore.currentmatter"
        :detail="$store.state.matterStore.currentmatter.case_details"
      />
    </div>
    <!-- Category -->
    <div
      v-if="
        Object.keys($store.state.matterStore.currentmatter).includes('category')
      "
    >
      <category-details
        :matter="$store.state.matterStore.currentmatter"
      />
    </div>
    <!-- Linked Matters -->
    <div
      v-if="
        Object.keys($store.state.matterStore.currentmatter).includes(
          'linked_matters'
        )
      "
    >
      <linked-matters
        v-if="$store.state.matterStore.currentmatter.linked_matters"
        :matter="$store.state.matterStore.currentmatter"
      />
    </div>
    <!-- Peitioner & Respondent -->
    <div>
      <petitioner-respondents
        :matter="$store.state.matterStore.currentmatter"
      />
    </div>

    <!-- Listening History -->
    <div
      v-if="
        Object.keys($store.state.matterStore.currentmatter).includes(
          'listing_history'
        )
      "
    >
      <listing-details
        :matter="$store.state.matterStore.currentmatter"
      />
    </div>

    <b-card no-body>
      <app-collapse accordion>
        <app-collapse-item
          v-if="
            Object.keys($store.state.matterStore.currentmatter).includes(
              'notices'
            )
          "
          title="Notices"
        >
          <DynamicListTable
            :data="$store.state.matterStore.currentmatter.notices"
            title=""
          />
        </app-collapse-item>
        <app-collapse-item
          v-if="
            Object.keys($store.state.matterStore.currentmatter).includes(
              'tagged_matters'
            )
          "
          title="Tagged Matters"
        >
          <DynamicListTable
            :data="$store.state.matterStore.currentmatter.tagged_matters"
            title=""
          />
        </app-collapse-item>
        <app-collapse-item
          v-if="
            Object.keys($store.state.matterStore.currentmatter).includes(
              'listing_dates'
            )
          "
          title="Listing Dates"
        >
          <DynamicListTable
            :data="$store.state.matterStore.currentmatter.listing_dates"
            title=""
          />
        </app-collapse-item>
        <app-collapse-item
          v-if="
            Object.keys($store.state.matterStore.currentmatter).includes(
              'drop_note'
            )
          "
          title="Drop Notes"
        >
          <DynamicListTable
            :data="$store.state.matterStore.currentmatter.drop_note"
            title=""
          />
        </app-collapse-item>
        <app-collapse-item
          v-if="
            Object.keys($store.state.matterStore.currentmatter).includes(
              'other_documents'
            )
          "
          title="Other Documents"
        >
          <DynamicListTable
            :data="$store.state.matterStore.currentmatter.other_documents"
            title=""
          />
        </app-collapse-item>
        <app-collapse-item
          v-if="
            Object.keys($store.state.matterStore.currentmatter).includes(
              'court_fees'
            )
          "
          title="Court Fees"
        >
          <DynamicListTable
            :data="$store.state.matterStore.currentmatter.court_fees"
            title=""
          />
        </app-collapse-item>
        <app-collapse-item
          v-if="
            Object.keys($store.state.matterStore.currentmatter).includes(
              'mention_memo'
            )
          "
          title="Mention Memo"
        >
          <DynamicListTable
            :data="$store.state.matterStore.currentmatter.mention_memo"
            title=""
          />
        </app-collapse-item>
        <app-collapse-item
          v-if="
            Object.keys($store.state.matterStore.currentmatter).includes(
              'caveat'
            )
          "
          title="Caveat"
        >
          <DynamicListTable
            :data="$store.state.matterStore.currentmatter.caveat"
            title=""
          />
        </app-collapse-item>
        <app-collapse-item
          v-if="
            Object.keys($store.state.matterStore.currentmatter).includes(
              'similaraties'
            )
          "
          title="Similaraties"
        >
          <DynamicListTable
            :data="$store.state.matterStore.currentmatter.similaraties"
            title=""
          />
        </app-collapse-item>
        <app-collapse-item
          v-if="
            Object.keys($store.state.matterStore.currentmatter).includes(
              'defects'
            )
          "
          title="Defects"
        >
          <DynamicListTable
            :data="$store.state.matterStore.currentmatter.defects"
            title=""
          />
        </app-collapse-item>
        <app-collapse-item
          v-if="
            Object.keys($store.state.matterStore.currentmatter).includes(
              'earlier_court_details'
            )
          "
          title="Earlier Court Details"
        >
          <DynamicListTable
            :data="$store.state.matterStore.currentmatter.earlier_court_details"
            title=""
          />
        </app-collapse-item>
        <app-collapse-item
          v-if="
            Object.keys($store.state.matterStore.currentmatter).includes('ia')
          "
          title="IA Details"
        >
          <CollapseListItem
            :data="$store.state.matterStore.currentmatter.ia"
          />
        </app-collapse-item>
      </app-collapse>
    </b-card>

    <!-- IA Details -->
    <!-- <div
        v-if="Object.keys($store.state.matterStore.currentmatter).includes('ia')"
      >
        <DynamicListTable
          :data="$store.state.matterStore.currentmatter.ia"
          title="IA Details"
        ></DynamicListTable>
      </div> -->
  </div>
</template>

<script>
import { BRow, BCol, BCard } from 'bootstrap-vue'
// Section Imports
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import BasicDetails from './components/basic-details/BasicDetails.vue'
import CaseStatus from './components/status/CaseStatus.vue'
import ListingDetails from './components/listing-history/ListingDetails.vue'
import PetitionerRespondents from './components/petitioner-respondent/PetitionerRespondents.vue'
import DynamicListTable from './components/DynamicListTable.vue'
import CategoryDetails from './components/CategoryDetails.vue'
import LinkedMatters from './components/LinkedMatters.vue'
import LowerCourt from './components/LowerCourt.vue'
import CrimeDetails from './components/CrimeDetails.vue'
import BasicTable from './components/tables/BasicTable.vue'
import CollapseListItem from './components/CollapseListItem.vue'

export default {
  components: {
    BRow,
    BCard,
    BCol,
    // Basic Details
    BasicDetails,
    CaseStatus,
    ListingDetails,
    PetitionerRespondents,
    DynamicListTable,
    CategoryDetails,
    LinkedMatters,
    LowerCourt,
    CrimeDetails,
    BasicTable,
    AppCollapse,
    AppCollapseItem,
    CollapseListItem,
  },
}
</script>
